module.exports = __webpack_public_path__ + "27d4d2a2f4bab97e26683713c27fc49a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/building.jpeg
// module id = 635
// module chunks = 0